import { baseQuery } from '../baseQuery';

type SendJobSmsParams = {
  id: number;
  message: string;
  to_number: string;
  sms_to: 'C' | 'T' | 'O';
};

export const postJobSendSms = async ({ id, message, to_number, sms_to }: SendJobSmsParams) => {
  const data = await baseQuery(`jobs/${id}/sms`, {
    type: 'POST',
    body: {
      message,
      to_number,
      sms_to,
    },
  });

  return data;
};
